module.exports = __webpack_public_path__ + "img/enroll_comp_img.e79aab22.png";